import numbro from 'numbro';

export function formatPrice(price?: string | number): string {
  const x = price ? +price : 0;
  const p = isNaN(x) ? 0 : x;
  return numbro(p).formatCurrency({ mantissa: 2 });
}
